import * as React from "react";
import { Box, Card, CardActions, Button, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { useTranslate } from "react-admin";
import publishArticleImage from "./welcome_illustration.svg";
import { triggerAuditLogModal } from "../../components/AuditLogGlobalModal";

const Welcome = () => {
  const translate = useTranslate();

  return (
    <Card
      sx={{
        background: (theme) =>
          `linear-gradient(45deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.light} 50%, ${theme.palette.primary.dark} 100%)`,
        color: (theme) => theme.palette.primary.contrastText,
        padding: "20px",
        marginTop: 2,
        marginBottom: "1em",
      }}
    >
      <Box display="flex">
        <Box flex="1">
          <Typography variant="h5" component="h2" gutterBottom>
            {translate("mine.label.dashboard_title")}
          </Typography>
          <Box maxWidth="40em">
            <Typography variant="body1" component="p" gutterBottom>
              {translate("mine.label.dashboard_subtitle")}
            </Typography>
          </Box>
          <CardActions
            sx={{
              display: "flex",
              flexWrap: { xs: "wrap", md: "nowrap" },
              gap: 1, // spasi antar tombol
              padding: { xs: 0, md: 1 },
            }}
          >
            {/* Tombol utama trigger modal */}
            <Button
              variant="contained"
              color="primary"
              onClick={triggerAuditLogModal}
              sx={{ whiteSpace: "nowrap" }}
            >
              Sinkronisasi Data Depo ke Pusat
            </Button>

            {/* Tombol kontak WA support depo */}
            <Button
              variant="contained"
              color="success"
              href="https://wa.me/+6287782280505"
              target="_blank"
              startIcon={<WhatsAppIcon />}
              sx={{ whiteSpace: "nowrap" }}
            >
              {translate("mine.label.dashboard_contact_dp_support")}
            </Button>

            {/* Tombol kontak WA IT */}
            <Button
              variant="contained"
              color="secondary"
              href="https://wa.me/+6287782280505"
              target="_blank"
              startIcon={<WhatsAppIcon />}
              sx={{ whiteSpace: "nowrap" }}
            >
              {translate("mine.label.dashboard_contact_it")}
            </Button>

            {/* Tombol Tutorial YouTube */}
            <Button
              variant="contained"
              color="error"
              href="https://depo.cjfi.co.id/file/filetodepo?page=1"
              target="_blank"
              startIcon={<OndemandVideoIcon />}
              sx={{ whiteSpace: "nowrap" }}
            >
              Tutorial
            </Button>
          </CardActions>

        </Box>
        <Box
          display={{ xs: "none", sm: "none", md: "block" }}
          sx={{
            background: `url(${publishArticleImage}) top right / cover`,
            marginLeft: "auto",
          }}
          width="16em"
          height="9em"
          overflow="hidden"
        />
      </Box>
    </Card>
  );
};

export default Welcome;
